import { TableOptions } from '@/types/table';
import { Transition } from '@headlessui/react';
import { Row } from '@tanstack/react-table';
import styles from '../Table.module.scss';
import { transitionClasses } from '../utils/constants';

const RowExtension = <T,>({
  row,
  options,
  rowExpandedDelayed,
}: {
  row: Row<T>;
  options?: TableOptions<T>;
  rowExpandedDelayed: Record<string, boolean>;
}) => {
  if (!row.getIsExpanded() || !options?.rowExtension) return null;

  return (
    <tr className={styles.expanded}>
      <td colSpan={row.getVisibleCells().length + 1}>
        <Transition as="div" show={rowExpandedDelayed[row.id] ?? false} {...transitionClasses}>
          {options?.rowExtension(row.original)}
        </Transition>
      </td>
    </tr>
  );
};

export default RowExtension;
